import Vue from 'vue'
import { axios } from '@/utils/request'
import signMd5Utils from '@/utils/encryption/signMd5Utils'
import moment from 'moment';
import { ACCESS_TOKEN,  TIME_DIFFERENCE} from "@/store/mutation-types"
const api = {
  user: '/mock/api/user',
  role: '/mock/api/role',
  service: '/mock/api/service',
  permission: '/mock/api/permission',
  permissionNoPager: '/mock/api/permission/no-pager'
}

export default api

//post
export function postAction(url, parameter) {
  let sign = signMd5Utils.getSign(url, parameter);
  //将签名和时间戳，添加在请求接口 Header
  let diff = window.sessionStorage.getItem(TIME_DIFFERENCE) || 0;
  let signHeader = { "X-Sign": sign, "X-TIMESTAMP": signMd5Utils.getDateTimeToStringDiff( diff) };

  return axios({
    url: url,
    method: 'post',
    data: parameter,
    headers: signHeader
  })
}

// post
export function postParamsAction(url, data, params) {
  let sign = signMd5Utils.getSign(url, data);
  //将签名和时间戳，添加在请求接口 Header
  let diff = window.sessionStorage.getItem(TIME_DIFFERENCE) || 0;
  let signHeader = { "X-Sign": sign, "X-TIMESTAMP": signMd5Utils.getDateTimeToStringDiff(diff) };

  return axios({
    url: url,
    method: 'post',
    data: data,
    params: params,
    headers: signHeader
  })
}

//post method= {post | put}
export function httpAction(url, parameter, method) {
  let sign = signMd5Utils.getSign(url, parameter);
  //将签名和时间戳，添加在请求接口 Header
  let diff = window.sessionStorage.getItem(TIME_DIFFERENCE) || 0;
  let signHeader = { "X-Sign": sign, "X-TIMESTAMP": signMd5Utils.getDateTimeToStringDiff(diff) };

  return axios({
    url: url,
    method: method,
    data: parameter,
    headers: signHeader
  })
}

//put
export function putAction(url, parameter) {
  let sign = signMd5Utils.getSign(url, parameter);
  //将签名和时间戳，添加在请求接口 Header
  let diff = window.sessionStorage.getItem(TIME_DIFFERENCE) || 0;
  let signHeader = { "X-Sign": sign, "X-TIMESTAMP": signMd5Utils.getDateTimeToStringDiff(diff) };

  return axios({
    url: url,
    method: 'put',
    data: parameter,
    headers: signHeader
  })
}

//get
export function getAction(url, parameter) {
  let sign = signMd5Utils.getSign(url, parameter);
  //将签名和时间戳，添加在请求接口 Header
  let diff = window.sessionStorage.getItem(TIME_DIFFERENCE) || 0;
  let signHeader = { "X-Sign": sign, "X-TIMESTAMP": signMd5Utils.getDateTimeToStringDiff(diff) };

  return axios({
    url: url,
    method: 'get',
    params: parameter,
    headers: signHeader
  })
}

//deleteAction
export function deleteAction(url, parameter) {
  return axios({
    url: url,
    method: 'delete',
    params: parameter
  })
}

export function getUserInfoByToken(token, parameter = {}) {
  let url = '/sys/portal/user/queryLoginUser'
  let sign = signMd5Utils.getSign(url, parameter);
  let signHeader = { "X-Sign": sign, "X-TIMESTAMP": signMd5Utils.getDateTimeToString(), 'X-Access-Token': token };
  return axios({
    url,
    method: 'get',
    data: parameter,
    headers: signHeader
  })
}

export function getUserList(parameter) {
  return axios({
    url: api.user,
    method: 'get',
    params: parameter
  })
}

export function getRoleList(parameter) {
  return axios({
    url: api.role,
    method: 'get',
    params: parameter
  })
}

export function getServiceList(parameter) {
  return axios({
    url: api.service,
    method: 'get',
    params: parameter
  })
}

export function getPermissions(parameter) {
  return axios({
    url: api.permissionNoPager,
    method: 'get',
    params: parameter
  })
}

// id == 0 add     post
// id != 0 update  put
export function saveService(parameter) {
  return axios({
    url: api.service,
    method: parameter.id == 0 ? 'post' : 'put',
    data: parameter
  })
}

/**
 * 下载文件 用于excel导出
 * @param url
 * @param parameter
 * @returns {*}
 */
export function downFile(url, parameter) {
  return axios({
    url: url,
    params: parameter,
    method: 'get',
    responseType: 'blob'
  })
}

/**
 * 下载文件
 * @param url 文件路径
 * @param fileName 文件名
 * @param parameter
 * @returns {*}
 */
export function downloadFile(url, fileName, parameter,that) {
  // that?(that.confirmLoading!==undefined?that.confirmLoading = true:that.loading = true):'';
  if(that){
    that.confirmLoading!==undefined?that.confirmLoading = true:that.loading = true
  }
  return downFile(url, parameter).then((data) => {
    // that.confirmLoading = false;
    // (that&&that.confirmLoading!==undefined?that.confirmLoading = false:that.loading = false;
    if(that){
      that.confirmLoading!==undefined?that.confirmLoading = false:that.loading = false
    }
    if (!data || data.size === 0) {
      Vue.prototype['$message'].warning(that.$store.getters.language['common.fileDowloadError'])
      return
    }
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(new Blob([data]), fileName)
    } else {
      let url = window.URL.createObjectURL(new Blob([data]))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) //下载完成移除元素
      window.URL.revokeObjectURL(url) //释放掉blob对象
    }
  })
}
export function downloadFileAll(applicationCode, fileNames,that,ZIPName) {
  // let url = "/sys/common/downLoadAll?applicationCode="+applicationCode+"&token="+Vue.ls.get(ACCESS_TOKEN)
  let url = "/sys/common/downLoadAll"
  let map = {};
  map.applicationCode = applicationCode
  map.token = Vue.ls.get(ACCESS_TOKEN)
  map.fileNames = fileNames;
  that.confirmLoading = true;
  return axios({
    url: url,
    data: map,
    method: 'post',
    responseType: 'blob'
  }).then((data) => {
    that.confirmLoading = false;
    if (!data || data.size === 0) {
      Vue.prototype['$message'].warning(that.$store.getters.language['common.fileDowloadError'])
      return
    }
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(new Blob([data]), fileName)
    } else {
      let url = window.URL.createObjectURL(new Blob([data]))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', ZIPName?ZIPName:"download.zip")
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) //下载完成移除元素
      window.URL.revokeObjectURL(url) //释放掉blob对象
    }
  })

}

/**
 * 文件上传 用于富文本上传图片
 * @param url
 * @param parameter
 * @returns {*}
 */
export function uploadAction(url, parameter) {
  return axios({
    url: url,
    data: parameter,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',  // 文件上传
    },
  })
}

/**
 * 获取文件服务访问路径
 * @param avatar
 * @param subStr
 * @returns {*}
 */
export function getFileAccessHttpUrl(avatar, uploadSource, subStr) {
  if (!subStr) subStr = 'http'
  try {
    // // 存在特殊字符， 转义
    // if (avatar && avatar.match(/[!*‘;:@&=+$,/?#\[\]]/g)) {
    //   avatar = encodeURI(avatar)
    // }
    if (avatar && avatar.startsWith(subStr) && avatar.indexOf('token') == -1) {
      if(avatar.indexOf('?') == -1){
        avatar = avatar + "?token="+Vue.ls.get(ACCESS_TOKEN)
        console.log('avatar1 = ', avatar)
      }else{
        avatar = avatar + "&token="+Vue.ls.get(ACCESS_TOKEN)
        console.log('avatar2 = ', avatar)
      }
      return avatar;
    } else if (avatar && avatar.length > 0 && avatar.indexOf('[') == -1) {
        if (uploadSource) {
          let path = window._CONFIG['staticDomainURL'] + "/" + avatar + "?applicationCode=" + uploadSource+"&token="+Vue.ls.get(ACCESS_TOKEN);
          console.log('avatar3 = ', path)
          return path
          // return window._CONFIG['staticDomainURL'] + "/" + avatar + "?applicationCode=" + uploadSource;
        } else {
          let path = window._CONFIG['staticDomainURL'] + "/" + avatar+"?token="+Vue.ls.get(ACCESS_TOKEN)
          console.log('avatar4 = ', path)
          return path
          // return window._CONFIG['staticDomainURL'] + "/" + avatar
        }
    } else {
      console.log('原路径：', avatar)
      return avatar
    }
  } catch (err) {
    return;
  }
}


export function handleExportPdf(url, fileName, param){
  console.log("导出参数",param)
  downFile(url, param).then((data)=>{
    if (!data) {
      this.$message.warning("文件下载失败")
      return
    }
    let date = new Date()
    let dateStr = moment(date).format('YYYY-MM-DD HH mm ss')
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(new Blob([data],{type: 'application/vnd.ms-excel'}), fileName+dateStr+'.pdf')
    }else{
      let url = window.URL.createObjectURL(new Blob([data],{type: 'application/vnd.ms-excel'}))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName+dateStr+'.pdf')// 也可使用 link.download = fileName 定义下载文件名
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link); //下载完成移除元素
      window.URL.revokeObjectURL(url); //释放掉blob对象
    }
  })
}
